export default __webpack_public_path__ + "static/media/lb.63fd4471.svg";